export const TESTIMONIAL_LIST_TWO = [
  {
    id: 1,
    text: "Destacamos la excelente asesoría, la atención personalizada y el compromiso constante por brindarnos las mejores soluciones para la protección de nuestro negocio.\"",
    // src: TESTI_AVATAR01,
    title: "Carlos Martínez",
    designation: "Gerente",
  },
  {
    id: 2,
    text: "Con la Agencia Omaira Barbosa, proteges lo que más valoras: tu familia y tu patrimonio, con confianza y soluciones hechas a tu medida.\"",
    // src: TESTI_AVATAR02,
    title: "Laura Gómez",
    designation: "Emprendedora",
  },
];
